import { render } from "./resetPassword.vue?vue&type=template&id=1dba148c"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/resetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dba148c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dba148c', __exports__)) {
    console.log('reload')
    api.reload('1dba148c', __exports__)
  }
  
  module.hot.accept("./resetPassword.vue?vue&type=template&id=1dba148c", () => {
    console.log('re-render')
    api.rerender('1dba148c', render)
  })

}


export default __exports__